/* ── Balcour Components v3 ── */
(function() {
  'use strict';

  /* ── Accordion ── */
  document.addEventListener('click', function(e) {
    var head = e.target.closest('[data-bc-acc]');
    if (!head) return;
    var item = head.closest('.bc-acc-item');
    if (!item) return;
    var body = item.querySelector('.bc-acc__body');
    if (!body) return;

    if (item.classList.contains('is-open')) {
      body.style.maxHeight = '0';
      item.classList.remove('is-open');
    } else {
      /* Close siblings */
      document.querySelectorAll('.bc-acc-item.is-open').forEach(function(sib) {
        if (sib === item) return;
        sib.classList.remove('is-open');
        var sb = sib.querySelector('.bc-acc__body');
        if (sb) sb.style.maxHeight = '0';
      });
      item.classList.add('is-open');
      body.style.maxHeight = body.scrollHeight + 'px';
    }
  });

  /* ── Tabs ── */
  document.addEventListener('click', function(e) {
    var head = e.target.closest('.bc-tab__head');
    if (!head) return;
    var item = head.closest('.bc-tab-item');
    if (!item) return;
    var body = item.querySelector('.bc-tab__body');
    if (!body) return;

    if (item.classList.contains('is-open')) {
      body.style.maxHeight = '0';
      item.classList.remove('is-open');
      head.setAttribute('aria-expanded', 'false');
    } else {
      /* Close siblings */
      document.querySelectorAll('.bc-tab-item.is-open').forEach(function(sib) {
        if (sib === item) return;
        sib.classList.remove('is-open');
        var sb = sib.querySelector('.bc-tab__body');
        if (sb) sb.style.maxHeight = '0';
        var btn = sib.querySelector('.bc-tab__head');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      item.classList.add('is-open');
      body.style.maxHeight = body.scrollHeight + 'px';
      head.setAttribute('aria-expanded', 'true');
    }
  });

  /* Init open-default accordions */
  function initDefaults() {
    document.querySelectorAll('.bc-acc-item .bc-acc__body').forEach(function(b) {
      if (parseInt(b.style.maxHeight) > 0) {
        b.closest('.bc-acc-item').classList.add('is-open');
        b.style.maxHeight = b.scrollHeight + 'px';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDefaults);
  } else {
    initDefaults();
  }
})();
